export const theme = {
  token: {
    colorPrimary: "rgb(230 31 38)",
  },
  components: {
    Input: {
      colorPrimaryHover: "rgb(230 31 38)",
      hoverBorderColor: "rgb(230 31 38)",
      activeBorderColor: "rgb(230 31 38)",
    },
    Select: {
      colorPrimaryHover: "rgb(230 31 38)",
      hoverBorderColor: "rgb(230 31 38)",
      activeBorderColor: "rgb(230 31 38)",
    },
    DatePicker: {
      colorPrimaryHover: "rgb(230 31 38)",
      hoverBorderColor: "rgb(230 31 38)",
      activeBorderColor: "rgb(230 31 38)",
    },
    TimePicker: {
      colorPrimaryHover: "rgb(230 31 38)",
      hoverBorderColor: "rgb(230 31 38)",
      activeBorderColor: "rgb(230 31 38)",
    },
  },
};
